// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

var Types = {};

var fragmentConverter = {"__root":{"":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

var Utils = {};

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationSettings_userNotificationSettings",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationSettingsForSaleProperties_notificationSetting"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationSettingsRentalProperties_notificationSetting"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationSettingsBuyerNeeds_notificationSetting"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationSettingsRentalNeeds_notificationSetting"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationSettingsBroadcastMessages_notificationSetting"
    }
  ],
  "type": "UserNotificationSettingsV5",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
